module.exports = __webpack_public_path__ + "assets/img/LTC006.2eb1e882.png";